import { render, staticRenderFns } from "./StepTemplate.vue?vue&type=template&id=cb1aa668&scoped=true&"
import script from "./StepTemplate.vue?vue&type=script&lang=js&"
export * from "./StepTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb1aa668",
  null
  
)

export default component.exports